
import { Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { envVariables } from "../../../../helpers";
import { useConsumosStore } from "../../../../store";
import { TooltipAndIcon } from "../../components/TooltipAndIcon";
import { useQueryClient } from "@tanstack/react-query";

import dayjs from "dayjs";
import Swal from "sweetalert2";
import { startEliminarConsumo } from "../../../../services";
const paginado = Number( envVariables.REACT_APP_PAGINADO);





export const TablaConsumoLote = ({ data, page, chagePage }) => {


    const queryClient = useQueryClient();
    const { totalConsumo } = useConsumosStore();


    const handleEliminarInfo = (id) => {
        Swal.fire({
            title: `Eliminar Consumo`,
            text: `¿Esta seguro de eliminar este consumo?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si, Eliminar` 
        }).then( async( result ) => {
            if(result.value){
                const resp = await startEliminarConsumo(id);
                if( resp ){
                    queryClient.invalidateQueries('consumo-lote');
                }
            }
        });
    }


    return (
        
        <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt:2 }}>
            <TableContainer sx={{ maxWidth:'100%' }}>
                <Table sx={{ minWidth: 700 }}>
                    <TableHead>						
                        <TableRow>
                            <TableCell sx={{width:'10%'}}>SEMANA</TableCell>
                            <TableCell sx={{width:'30%'}}>PRODUCTO</TableCell>
                            <TableCell sx={{width:'10%'}}>SUGERIDO</TableCell>
                            <TableCell sx={{width:'10%'}}>CANTIDAD</TableCell>
                            <TableCell sx={{width:'20%'}}>FECHA</TableCell>
                            <TableCell sx={{width:'10%'}}>OPCIONES</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(data.map( item => (
                            <TableRow key={item.id}>
                                <TableCell>{ item.semana }</TableCell>
                                <TableCell>{ item.producto.nombre }</TableCell>
                                <TableCell>{ item.sugerido }</TableCell>
                                <TableCell>{ item.cantidad }</TableCell>
                                <TableCell>{dayjs(item.fecha).format('DD/MMM/YY HH:mm').toUpperCase()}</TableCell>
                                <TableCell>
                                    <TooltipAndIcon
                                        titulo='Eliminar Consumo'
                                        icono='eliminar'
                                        onClick={ () => handleEliminarInfo(item.id) }
                                        color='red'
                                    />
                                </TableCell>
                            </TableRow>
                        )))}
                    </TableBody>
                </Table>

                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalConsumo / paginado)} disabled={Math.ceil(totalConsumo / paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            </TableContainer>
        </Paper>
    )
}
